// utils/useFeatureFlag.ts — W2.5 component-friendly feature-flag hook.
//
// Usage:
//   import { useFeatureFlag } from '../utils/useFeatureFlag';
//   const enabled = useFeatureFlag('history_drawer_enabled');
//   if (!enabled) return null;
//
// Returns false until flags have loaded (fail-closed) and false for any
// unregistered key. Loading is bootstrapped by `loadFeatureFlags()` called
// after authentication in App.tsx.

import { useFeatureFlags } from '../state/feature-flags';

export function useFeatureFlag(key: string): boolean {
  return useFeatureFlags((s) => s.flags[key] === 'on');
}

/** Returns the resolution source for a flag (debug + analytics). */
export function useFeatureFlagSource(key: string): 'student' | 'cohort' | 'school' | 'default' | undefined {
  return useFeatureFlags((s) => s.sources[key]);
}
